<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.eventStatus') }}
    </c-label>
    <div class="content-wrapper">
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.widgetName')) }}
        </ConfigTitle>
        <lego-text-field
          ref="widgetName"
          :rules="validator.widgetName"
          :modelValue="widgetName"
          counter="100"
          showCounter
          :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
          @update:modelValue="(value) => changeWidgetName(value)"
          isFreeText
        />
      </div>
      <BoxRegion class="area" />
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.retrieve')) }} {{ $t('label.scope') }}
        </ConfigTitle>
        <lego-segment-wrapper
          v-model="eventStateModel"
          style="width: 100%"
          @update:modelValue="changeEventStateModel()"
        >
          <lego-segment-button value="ALL" style="width: 50%"
            >{{ $util.capitalize($t('label.all1')) }} {{ $t('label.event') }}
          </lego-segment-button>
          <lego-segment-button value="ACTIVE" style="width: 50%"
            >{{ $t('label.subTextEventList') }}
          </lego-segment-button>
        </lego-segment-wrapper>
      </div>
    </div>
  </div>
</template>
<script>
import configMixin from './configMixin';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  props: ['configItem'],
  mixins: [configMixin, validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      isChanged: false,
      widgetName: '', // 위젯명
      eventStateModel: 'ALL', // 조회범위 (ALL: 모든이벤트, ACTIVE: 미조치 이벤트)
      defaultConfig: this.config({
        // 이벤트 현황 위젯 기본정보
        title: this.$t('title.eventStatus'),
        isResizable: true,
        h: 4,
        minW: 2,
        maxW: 8,
        minH: 2,
        maxH: 6,
        widget: {
          type: 'EventStausWidget',
          api: '/cloudmonitorings/event/v1/console/events/all-resource-types',
          options: {}
        }
      }),
      validator: {
        widgetName: [this.checkWidgetName]
      },
      validateFieldKey: 'eventStausWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    updateFieldsBeforeModify() {
      this.setFieldsBeforeModify();
    },
    validate() {
      return this.$util.validate([this.$refs.widgetName]);
    },
    setDefault() {
      const eventState = this.defaultConfig.chartAttr.widget.options.eventState;
      this.eventStateModel = eventState ? eventState : 'ALL';
      this.onConfigChange();
    },
    onConfigChange(isApiCall1 = true) {
      let configs = [];
      let config = this.getCommonConfig();
      config.chartAttr.title = this.widgetName;
      config.chartAttr.widget.options = { eventState: this.eventStateModel };
      config.isApiCall = isApiCall1;
      configs.push(config);

      this.checkCount++;
      if (this.checkCount === 1) this.originConfigs = configs;

      this.$emit('configModify', configs);
    },
    changeEventStateModel() {
      this.onConfigChange();
      this.changeData();
    }
  }
};
</script>
<style lang="scss" scoped>
.area {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 8px;
  }
}

.content-wrapper {
  margin-top: 24px;
}
</style>
